export enum WarehouseLocalizationListAction {
  Create,
}
